import BriidgeTheGapLogo from '@/assets/branding/briidgethegap/BriidgeTheGapLogo.png';

const colors = {
  // Brand colors
  brand_primary: '#0C33C1',
  brand_primary_hover: '#08227F', // −10 L, −8 S
  brand_primary_highlight: '#4767FF', // +23 L, +7 S
  brand_primary_mid: '#163FD9', // +8 L,  +2 S
  brand_primary_dark: '#02071F', // −25 L, −3 S (clamped)
  brand_secondary: '#071634', // hue +4°, −15 L, −13 S
  brand_accent_start: '#1A42D5',
  brand_accent_end: '#7B4AE0',
  brand_accent_light_start: '#E9EDFF',
  brand_accent_light_end: '#ECE6FF',
  brand_complementary_accent: 'rgb(216,172,13)',
  brand_auth_gradient_mid: '#071634',
  brand_auth_gradient_end: '#02071F',
  brand_auth_warp_mid: '#163FD9',
};

export default {
  name: 'Briidge The Gap',
  isSAML: true,
  allowPersonalCourses: false,
  logo: BriidgeTheGapLogo,
  colors,
};
